var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-data-table',{attrs:{"list-route":_vm.listRoute,"initial-filters":_vm.initialFilters,"grid-title":`${_vm.t('search::page.title.search')} <span class='font-weight-normal'>from</span> ${_vm.queryString}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }